import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import Text from '@/components/basic/text';
import theme from '@/style';
import React from 'react';
import LinearGradient from '@/components/basic/linear-gradient';
import {StyleSheet} from 'react-native';
import {useTranslation} from 'react-i18next';
const QuickBtn = ({onPress}: {onPress?: () => void}) => {
  const {
    i18n: {t},
  } = useTranslation();
  return (
    <NativeTouchableOpacity onPress={() => onPress && onPress()}>
      <LinearGradient style={styles.btn} colors={['#FCFCFE', '#F3F5FB']}>
        <Text
          fontFamily="fontInterBold"
          fontSize={12}
          color={theme.fontColor.main}>
          {t('game-page.label.quickGuess')}
        </Text>
      </LinearGradient>
    </NativeTouchableOpacity>
  );
};

const styles = StyleSheet.create({
  btn: {
    minWidth: 80,
    height: 40,
    paddingHorizontal: 12,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    elevation: 3,
    shadowColor: '#00000040',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
});

export default QuickBtn;
